import { render, staticRenderFns } from "./betsTable.vue?vue&type=template&id=dbdc0062&"
import script from "./betsTable.vue?vue&type=script&lang=js&"
export * from "./betsTable.vue?vue&type=script&lang=js&"
import style0 from "./betsTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "betsTable.vue"
export default component.exports